import { render, staticRenderFns } from "./zipcodes.vue?vue&type=template&id=3a3121f1&"
import script from "./zipcodes.vue?vue&type=script&lang=js&"
export * from "./zipcodes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports